
<template>
    <div id="faq-page">
        <!-- JUMBOTRON -->
        <div class="faq-jumbotron">
            <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
                <h1 class="mb-1 text-white">有问题吗?</h1>
                <p class="text-white">输入你想要知道的问题。</p>
                <vs-input placeholder="搜索" v-model="faqSearchQuery" icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6" icon-no-border />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/5 lg:w-1/5 rounded-lg">
                <vx-card>
                    <h4>问题分类</h4>
                    <ul class="faq-topics mt-4">
                        <li v-for="category in categories" :key="category.id" class="p-2 font-medium flex items-center" @click="faqFilter = category.id">
                            <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + category.color"></div><span class="cursor-pointer">{{ category.name }}</span>
                        </li>
                    </ul>

                    <br><br>

                    <h4>技术支持</h4>
                    <ul class="faq-supporters mt-4">
                        <li v-for="supporter in supporters" :key="supporter.id" class="mt-4">
                            <div class="flex items-center">
                                <!-- <vs-avatar class="mr-3" :src="require(`@/assets/images/portrait/small/${supporter.img}`)" size="35px" /> -->
                                <div class="leading-tight">
                                    <p class="font-semibold">{{ supporter.name }}</p>
                                    <small>{{ supporter.phone }}</small>
                                </div>
                            </div>
                        </li>
                    </ul>
                </vx-card>
            </div>

            <!-- FAQ COL -->
            <div class="vx-col w-full md:w-4/5 lg:w-4/5 mt-12 md:mt-0">
                <vs-collapse accordion type="margin" class="p-0">
                    <vs-collapse-item v-for="(que,index) in filteredFaq" class="faq-bg rounded-lg" :class="{'mt-0': !index}" :key="que.id">
                        <div slot="header"><h5>{{ que.question }}</h5></div>
                        <div v-html="que.ans"></div>
                    </vs-collapse-item>
                </vs-collapse>
                
            </div>
        </div>
    </div>
</template>

<script>

export default{
    data() {
        return {
            faqSearchQuery: '',
            faqFilter: 1,
            categories: [
                {
                    id: 1,
                    name: '全部',
                    color: 'grey',
                },
                {
                    id: 2,
                    name: '班级管理',
                    color: 'primary'
                },
                {
                    id: 3,
                    name: '学生管理',
                    color: 'success'
                },
                {
                    id: 4,
                    name: '课程中心',
                    color: 'warning'
                },
                {
                    id: 5,
                    name: '其他',
                    color: 'danger'
                },
            ],
            faqs: [
                {
                    id: 1,
                    categoryId: 2,
                    question: '如何添加班级?',
                    ans: '1.	在菜单栏中，点击进入“班级管理<br>2.	选择点击“新建班级<br>3.	在弹窗中，输入要创建的班级名称，比如“三年二班”。然后点击确定，即可添加成功。'
                },
                {
                    id: 2,
                    categoryId: 3,
                    question: '如何添加学生?',
                    ans: '1.	在已创建的班级中点选“添加学生”，此时有两种方式。一种是创建新的学生账号，另一种是添加已有账号的学生<br>2.	创建新的学生账号：输入要创建账号的学生姓名，使用换行进行分隔。比如这里创建张三和李四的账号。确认后会生成并导出学生的账号密码Excel表。（该表请老师妥善保存）<br>3.	添加已有的学生账号：即在平台已经注册过，但还没有加入任何学校的账号。'
                },
                {
                    id: 3,
                    categoryId: 4,
                    question: '如何发送资料?',
                    ans: '1.	可以发送的资料有：视频，课件，任务单。<br>2.	在课程中，选择需要发送的章节并进入。然后点击“发送资料”按钮。<br>3.	在弹出层中选择要发送的资料，以及发送的目标学生（可以是整个班级或单（多）个学生）。比如：这里选择视频mp4文件，发送给“张三”这个学生。<br>4.	学生即可在TA自己的课程学习页面看到视频。<br>5.	课程练习，也就是“去创作”按钮的打开的项目不需要发送。每个学生都会自动生成对应的课堂练习项目。'
                },
                {
                    id: 4,
                    categoryId: 4,
                    question: '如何查看课程项目?',
                    ans: '1.	教师在课程学习页面，点击“去创作”，可以查看本节课的“初始项目”和“完整项目”。<br>2.	初始项目：一般是带素材，但缺少代码的初始项目。<br>3.	完整项目：一般用于结果演示。'
                },
                {
                    id: 5,
                    categoryId: 4,
                    question: '如何查看学习情况?',
                    ans: '1.	教师在课程学习页面，点击“学习情况”，可以查看学生视频、课件等学习的完成情况。<br>'
                },
                {
                    id: 6,
                    categoryId: 4,
                    question: '如何查看课堂练习情况?',
                    ans: '1.	教师在课程学习页面，点击“练习情况”，可以查看学生本课堂项目的完成情况，并且给学生课堂项目进行评分。'
                },
                {
                    id: 7,
                    categoryId: 4,
                    question: '如何查看任务单完成情况?',
                    ans: '1.	部分课程可能没有任务单资源。<br>2.	教师在课程学习页面，点击“任务单”，然后在列表中选择需要查看的任务。'
                },
                {
                    id: 8,
                    categoryId: 5,
                    question: '学生忘记密码怎么办?',
                    ans: '1.	在学生管理中，查找或搜索学生的姓名或用户名<br>2.	然后点击重置密码，重置后的密码默认为08980899'
                },
                {
                    id: 9,
                    categoryId: 5,
                    question: '学生课程页面没有视频/任务单/列表?',
                    ans: '1.	可能是老师没有发送资料，联系老师重新发送'
                },
                {
                    id: 10,
                    categoryId: 5,
                    question: '课程显示未开通？如何开通课程?',
                    ans: '1.	需要学校联系平台方进行课程授权'
                },
                {
                    id: 11,
                    categoryId: 5,
                    question: '为什么我的课程章节列表显示带锁?',
                    ans: '1.	显示带锁说明进入了社区端，学生教师学习必须进入HAAI学堂进行学习'
                },
            ],
            supporters: [
                {
                    id: 1,
                    name: 'black9',
                    phone: '15607697616'
                },
            ]
        }
    },
    computed: {
        filteredFaq() { 
            return this.faqs.filter((faq) => {
                if (this.faqFilter == 1) return (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 2) return faq.categoryId == 2 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 3) return faq.categoryId == 3 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 4) return faq.categoryId == 4 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 5) return faq.categoryId == 5 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
            });
        }
    },
    methods: {
    },
    components: {
    }
}
</script>

<style lang="scss">
#faq-page {
    .faq-jumbotron-content {
        background-image: url('../../assets/images/pages/faq.jpg');
        background-size: cover;
    }

    .faq-bg {
        background-color: #fff;
    }   
}
</style>